'use strict';
/**
 * @author Maxim Seredkin
 * @param {$resource} $resource
 * @return {*}
 */
export default ['$resource',
    function($resource) {
        return $resource('api/support-stages/:supportStageId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/support-stages/:supportStageId/enable', method: 'PUT'},
            delete: {url: 'api/support-stages/:supportStageId/delete', method: 'PUT'},
            getDefault: {url: 'api/support-stages/default', method: 'GET'},
            setDefault: {url: 'api/support-stages/:supportStageId/default', method: 'PUT'},
            isUniqueName: {url: 'api/support-stages/unique/name/:name', method: 'GET'},
        });
    }];
